// Step config for the first-time landing-page guided tour (see
// components/tour/GuidedTour.jsx for the engine). Selectors target
// Landing.jsx's own data-testid attributes directly — that page predates
// the constants/testIds convention the auth pages use, so this matches
// its existing style rather than introducing a second convention there.
const landingTourSteps = [
    {
        selector: '[data-testid="landing-header"]',
        title: "Welcome!",
        text: "Welcome to Little Verses — 20 short poems to help kids learn Qur'anic words.",
    },
    {
        selector: '[data-testid="hero-play-first"]',
        title: "Try it free",
        text: "Tap here to watch Poem #1 right now — free, no sign-in needed.",
    },
    {
        selector: '[data-testid="hero-signin"]',
        title: "Sign in",
        text: "Sign in anytime to unlock all 20 poems and track your child's progress.",
    },
    {
        // Poem #1's own tile, not the whole library grid — the grid holds
        // all 20 poems and is far taller than the viewport (see the same
        // fix in onboardingTour.js's step 3).
        selector: '[data-testid="poem-tile-1"]',
        title: "The library",
        text: "Every poem lives here — a new one unlocks each week once you're signed in.",
    },
    {
        // Conditionally rendered — only shows once /settings/support loads
        // AND an admin has WhatsApp support turned on, so this step is a
        // real "may not exist" case, not just a slow fetch. GuidedTour's
        // own polling already handles that (skips straight past it if it
        // never appears), so nothing extra needed here.
        selector: '[data-testid="whatsapp-button"]',
        title: "Need help?",
        text: "Got a question? Tap here anytime to chat with us on WhatsApp.",
    },
];

export default landingTourSteps;
